/**
 * Video Modal — open/close lightbox playing video
 * Lazy-set <source> only on open → tránh download video lúc page load.
 */
(function () {
  const modal = document.getElementById('videoModal');
  if (!modal) return;

  const video   = modal.querySelector('.video-modal__video');
  const openBtns  = document.querySelectorAll('[data-video-modal-open]');
  const closeBtns = modal.querySelectorAll('[data-video-modal-close]');
  const videoSrc  = video && video.getAttribute('data-video-src');

  if (!video || !videoSrc) return;

  function openModal() {
    if (!video.src) video.src = videoSrc; // lazy-load
    modal.hidden = false;
    document.body.classList.add('is-video-modal-open');
    // attempt autoplay (some browsers will require user gesture; click counts)
    video.play().catch(() => {});
  }

  function closeModal() {
    modal.hidden = true;
    document.body.classList.remove('is-video-modal-open');
    video.pause();
    // Reset to start for next open
    try { video.currentTime = 0; } catch (e) { /* ignore */ }
  }

  openBtns.forEach((btn) => btn.addEventListener('click', openModal));
  closeBtns.forEach((btn) => btn.addEventListener('click', closeModal));

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !modal.hidden) closeModal();
  });
})();
